import { useState } from "react";
import {
  Alert,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useSelector } from "react-redux";

const PackageNotificationSwitch = ({
  pkg,
  customer,
  defaultEnabled = false,
  onSaved,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const enabled = pkg?.notifications?.enabled ?? defaultEnabled;
  const overridden = pkg?.notifications?.overridden === true;

  const handleChange = async (e) => {
    const next = e.target.checked;
    try {
      setSaving(true);
      setError("");

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/admin/update-package-notification`,
        {
          currentSession,
          task_id: pkg?.task_id,
          cst_packageID: pkg?.cst_packageID,
          customer,
          enabled: next,
        },
        { withCredentials: true },
      );

      if (resp?.data?.success) {
        onSaved?.({
          ...pkg,
          notifications: { enabled: next, overridden: true },
        });
      } else {
        setError(
          resp?.data?.message || "Failed to update notification setting",
        );
      }
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to update notification setting",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack spacing={1}>
      <FormControlLabel
        control={
          <Switch checked={enabled} onChange={handleChange} disabled={saving} />
        }
        label="Send configured notifications on signature completion and NOC recording"
      />
      <Typography variant="caption" color="text.secondary">
        {overridden
          ? "Overridden for this package only."
          : "Using the contractor's default."}
      </Typography>
      {error && (
        <Alert severity="error" onClose={() => setError("")}>
          {error}
        </Alert>
      )}
    </Stack>
  );
};

export default PackageNotificationSwitch;
